/**
 * Image aspect for the grid card. Shared with ProductCardSkeleton so the two
 * cannot drift — a skeleton on a different aspect reflows the moment it swaps
 * for the real card.
 *
 * Kept out of ProductCard.tsx on purpose: that module is "use client", and a
 * server component (every listing loading.tsx renders the skeleton) importing
 * a plain value from it gets a client reference, not the object. The lookup
 * then returned undefined in production and the skeleton images collapsed.
 */
export const CARD_IMAGE_ASPECT = {
  portrait: "aspect-[3/4]",
  square: "aspect-square",
} as const;

export type CardImageAspect = keyof typeof CARD_IMAGE_ASPECT;
